// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"554":"e9f867d1","802":"9c4184b0"}[chunkId] + ".chunk.css";
};